import React from 'react';

import { H1, P } from '../elements/Text';
import Button from '../elements/Button';
import styled from 'styled-components';
import { AssessmentTestContext } from '../../contexts/assessment-test';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  max-width: 820px;
  margin: 0 auto;
  margin-top: 72px;
  padding-bottom: 72px;
`;

export function TestIntro() {
  const [, dispatch] = React.useContext(AssessmentTestContext);

  const onStartTest = () => {
    dispatch({ type: 'START_TEST', timestamp: new Date() });
  };

  return (
    <>
      <Wrapper>
        <H1 style={{ marginTop: 32 }}>Welcome 👋</H1>
        <P>
          You've been invited to complete an interactive assessment designed to
          evaluate your skills across key areas of AI engineering and
          architecture.
        </P>
        <P>
          <strong>What to expect?</strong>
          <ul>
            <li>
              We'll start with a round of{' '}
              <strong>quick-fire self-assessment questions</strong>, then move
              on to <strong>real-world scenarios</strong> focused on applied
              problem-solving.
            </li>
            <li>
              <strong>Each scenario consists of several questions.</strong>{' '}
              These will include a mix of multiple choice, interactive coding or
              puzzles, and open-ended text questions.
            </li>
            <li>
              This assessment should take ~40 minutes, with a hard stop at 60
              minutes.
            </li>
            <li>
              To get through the whole test in time,{' '}
              <strong>aim to spend ~5 minutes per scenario</strong>.
            </li>
            <li>
              If you're tight on time, use the last question in each scenario to
              add comments about what you would've done with more time.
            </li>
          </ul>
        </P>
        <P>
          When you're ready, hit <strong>Start Test</strong> and dive in!
        </P>
        <div>
          <Button
            type="primary"
            label="Start Test"
            onClick={onStartTest}
            faIcon="fa-solid fa-play"
          />
        </div>
      </Wrapper>
    </>
  );
}
